<ng-container *transloco="let t;">
    <div class="contract-control-step-three">
        <h2 class="step-heading-title">{{t('Heading text (contractControl stepForm) - Revenue')}}</h2>
        
        <div class="revenuePreviewCard-wrapper table-responsive mt-1">
            <table class="table table-hover table-striped">
                <thead>
                    <tr>
                        <th class="col-width">{{ t('Contract control box field title (Contract control section) - Description') }}</th>
                        <th>{{ t('Contract control box field title (Contract control section) - Billing start date') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for(control of revenueControls.controls; track control; let i = $index) {
                        <tr>
                            <td class="col-width" (click)="openRevenueFormModal(control.value, i)">
                                <span class="revenue_description">{{ control.get('description')?.value }}</span>
                                <div>
                                    <span class="revenue_amount">{{ control.get('revenue_amount')?.value | numberFormatPipe }} {{ control.get('revenue_currency')?.value }}</span> /
                                    <span class="revenue_billing_frequency">{{ control.get('billing_frequency')?.value }}</span>
                                </div>
                            </td>
                            <td (click)="openRevenueFormModal(control.value, i)"><span class="hover-effect">{{ control.get('billing_start')?.value | dateFormat | async}}</span></td>
                            <td class="text-end" (click)="removeRevenue(i)">
                                <i data-feather="trash-2" class="cursor-pointer text-danger"></i>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            
            <button type="button" class="btn btn-primary btn-sm mt-1" 
                (click)="openRevenueFormModal()">
                <i data-feather="plus" class="me-25"></i>
                {{t('Add revenue button text - (Contract control revenue card) - Add revenue')}}
            </button>
        </div>
    </div>
</ng-container>
